import { Expose, Transform, TransformFnParams } from '@nts/std/serialization';
import { AuditModelInterface } from './audit-model.interface';
import { BaseIdentity } from './base-identity';
import { DateTimeOffset } from './date-time-offset';
import { DeactivableModelInterface } from './deactivable-model.interface';
import { OCCModel } from './occ-model';
import { StringDecorator } from './decorators/string.decorator';
import { DateDecorator } from './decorators/date.decorator';
import { BoolDecorator } from './decorators/bool.decorator';

export class OCCAuditDeactivableModel<TIdentity extends BaseIdentity>
  extends OCCModel<TIdentity> implements AuditModelInterface, DeactivableModelInterface {

  static override PROPERTY_LIST: string[] = [
    ...OCCModel.PROPERTY_LIST,
    'updateUser',
    'updateDate',
    'creationUser',
    'creationDate',
    'isActive'
  ];

  constructor() {
    super();
    this.isActive = true;
  }

  private _updateUser: string;

  @Expose()
  @StringDecorator({
    displayNameKey: 'std_OCCAuditDeactivableModel_UpdateUser',
  })
  get updateUser(): string {
    return this.getValue<string>(() => this._updateUser, 'updateUser');
  }
  set updateUser(value: string) {
    this.setValue<string>(() => { this._updateUser = value; }, value, 'updateUser');
  }

  private _updateDate: Date;

  @Expose()
  @DateDecorator({
    displayNameKey: 'std_OCCAuditDeactivableModel_UpdateDate',
    isDateTimeOffset: true
  })
  @Transform((params: TransformFnParams) => {
    return DateTimeOffset.transform('updateDate', params);
  })
  get updateDate(): Date {
    return this.getValue<Date>(() => this._updateDate, 'updateDate');
  }
  set updateDate(value: Date) {
    this.setValue<Date>(() => { this._updateDate = value; }, value, 'updateDate');
  }

  private _creationUser: string;

  @Expose()
  @StringDecorator({
    displayNameKey: 'std_OCCAuditDeactivableModel_CreationUser',
  })
  get creationUser(): string {
    return this.getValue<string>(() => this._creationUser, 'creationUser');
  }
  set creationUser(value: string) {
    this.setValue<string>(() => { this._creationUser = value; }, value, 'creationUser');
  }

  private _creationDate: Date;

  @Expose()
  @DateDecorator({
    displayNameKey: 'std_OCCAuditDeactivableModel_CreationDate',
    isDateTimeOffset: true
  })
  @Transform((params: TransformFnParams) => {
    return DateTimeOffset.transform('creationDate', params);
  })
  get creationDate(): Date {
    return this.getValue<Date>(() => this._creationDate, 'creationDate');
  }
  set creationDate(value: Date) {
    this.setValue<Date>(() => { this._creationDate = value; }, value, 'creationDate');
  }

  private _isActive: boolean;

  @Expose()
  @BoolDecorator({
    displayNameKey: 'std_OCCAuditDeactivableModel_IsActive',
  })
  get isActive(): boolean {
    return this.getValue<boolean>(() => this._isActive, 'isActive');
  }
  set isActive(value: boolean) {
    this.setValue<boolean>(() => { this._isActive = value; }, value, 'isActive');
  }
}
